export default "__VITE_ASSET__CPHbj46p__"